module.exports = __webpack_public_path__ + "static/media/bg13.c9b95f45.jpg";